import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import ObjectivesTrackerCreateTriggerButton from "../detail/ObjectivesTrackerCreateTriggerButton";
import CreateSubgoalForm from "./CreateSubgoalForm";
import { useTranslation } from "react-i18next";

const CreateSubgoalDialog = ({ onSubmitHandler, parentGoal, selectables }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (values) => {
    setIsOpen(false);
    onSubmitHandler(values);
  };

  return (
    <DialogFormPanel
      trigger={<ObjectivesTrackerCreateTriggerButton />}
      title={t("objectivesTracker.createSubgoalForm.title")}
      description={t("objectivesTracker.createSubgoalForm.description")}
      content={
        <CreateSubgoalForm
          onSubmitHandler={onSubmit}
          parentGoal={parentGoal}
          selectables={selectables}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateSubgoalDialog;
